<template>
    <page>
        <module>
            <module-tab title="系统配置">
                <c-form ref="form0">
                    <c-form title="PC/移动端配置">
                        <c-form-item type="radio" label="是否开通PC站" :options="switchOptions" name="PC_ENABLED" v-model="PC_ENABLED" ></c-form-item>
                        <c-form-item type="radio" label="是否开通移动端" :options="switchOptions" name="MOBILE_ENABLED" v-model="MOBILE_ENABLED"></c-form-item>
                        <c-form-item type="input" label="PC商城预览地址" name="PC_MALL_URL" v-show="PC_ENABLED == 'ON'"></c-form-item>
                        <c-form-item type="image" label="小程序二维码" name="MINI_CODE_IMG" v-show="PC_ENABLED == 'ON' && MOBILE_ENABLED == 'ON'" file-word="微信扫码可以打开小程序,【建议尺寸：480X480px,支持jpg、png，图片大小1M以内】" ></c-form-item>
                        <c-form-item type="radio" label="技术支持显示" :options="switchOptions"  name="SYS_TECHNICAL_SUPPORT_ENABLED"></c-form-item>
                    </c-form>
                    <c-form title="运营模式配置">
                        <c-form-item type="radio" label="销售模式" :options="saleMode"  name="SALE_MODE" ></c-form-item>
                        <c-form-item type="radio" label="商城模式" v-model="PT_MODE" :options="ptMode"  name="PT_MODE">
                             <span slot="word">
                                 注:如果平台支持分销功能，且存在多商家，<a style="color:red">则商家的【平台盈利模式】只能使用【加价销售】</a>
                             </span>
                        </c-form-item>
                        <c-form-item v-show="PT_MODE == 2" type="radio" label="展示运营模式" :options="switchOptions"  name="OPERATION_MODE_ENABLED" word="注:商城模式为【多商户运营】时有效，订单/商品等处展示"></c-form-item>
                        <c-form-item v-show="PT_MODE == 2" type="radio" label="展示商家角色名称" :options="switchOptions"  name="STATIONED_AUTHNAME_ENABLED" word="注:商城模式为【多商户运营】时有效，订单/商品等处展示"></c-form-item>
                        <c-form-item v-show="PT_MODE == 2" type="radio" label="商家修改品牌介绍" :options="switchOptions"  name="STATION_SHOP_CONTENT_ENABLED" word="注:商城模式为【多商户运营】时有效"></c-form-item>
                    </c-form>
                </c-form>
            </module-tab>
            <module-tab title="平台配置">
                <c-form ref="form1">
                    <c-form title="基本配置">
                        <c-form-item type="radio"  label="库存占用方式" :options="occupancyTypeOptions" name="INVENTORY_OCCUPANCY_TYPE">
                            <span slot="word">注:即平台可售库存在何时减少，<a style="color:red">如果选择【支付后占用库存】，则可能出现超卖情况</a></span>
                        </c-form-item>
                        <c-form-item type="radio" label="售卖虚拟商品" :options="switchOptions"  v-model="IS_VIRTUAL_PRODUCT" name="IS_VIRTUAL_PRODUCT">
                            <span slot="word">注:开启后，允许添加“虚拟商品”类目，虚拟商品无需物流发货，购买后生成卡券，线下核销；
                                允许售卖虚拟商品与<a style="color:red">【分销配置->云仓囤货】</a>功能互斥，开启云仓囤货则不允许售卖虚拟商品。
                            </span>
                        </c-form-item>
                        <c-form-item type="radio" label="商品货号必填" :options="switchOptions"  name="PRODUCT_NUMBER_REQUIRED" word="注:必填开启后会校验货号全局唯一"></c-form-item>
                        <c-form-item type="radio" label="支持业务员功能" :options="switchOptions"  name="SALESMAN_ENABLE" word="注:必填开启后代理展示业务员相关信息"></c-form-item>
                        <c-form-item type="radio" label="支持成长值功能" :options="switchOptions"  name="GROWTH_ENABLE" word="注:必填开启后代理展示成长值相关信息"></c-form-item>
                        <c-form-item type="radio" label="商品SKU编码规则" :options="skuCreateTypeOptions"  name="PRODUCT_SKU_CODE_AUTOCREATE_TYPE" ></c-form-item>
                        <c-form-item type="radio" label="商品分类层级" :options="productTypeLevelOptions"  name="SYS_PRODUCT_TYPE_LEVEL_COUNT" ></c-form-item>
                        <c-form-item type="radio" label="商品分类关联类型" :options="productTypeLinkType"  name="SYS_PRODUCT_TYPE_LINK_TYPE" ></c-form-item>
                        <c-form-item type="number" decimal="0" label="验证码位数"  name="VERIFY_CODE_LENGTH" :limit="[4,6]" input-unit="位">
                             <span slot="word"><a style="color:red">该数据修改后，需要重启ESB项目才能生效</a></span>
                        </c-form-item>
                    </c-form>
                    <c-form title="财务相关">
                        <c-form-item type="radio" label="余额支付"  :options="switchOptions"  name="ACCOUNT_BALANCE_ENABLED" word="充值等部分特殊功能无法使用余额支付"></c-form-item>
                        <c-form-item type="radio" label="转账支付支付"  :options="switchOptions"  name="CASH_PAY" word="转账支付支付订单，需要后台审核通过才算支付成功">
                            <span slot="word"><a class="s-link" @click="cashPayAccountConfig()">配置收款账户</a></span>
                        </c-form-item>
                        <c-form-item type="radio" label="授信支付"  :options="switchOptions"  name="CREDIT_PAY" word="充值等部分特殊功能无法使用授信支付"></c-form-item>
                        <c-form-item type="radio" label="微信支付"  :options="switchOptions" v-model="WECHAT_PAY"  name="WECHAT_PAY" >
                            <span v-show="WECHAT_PAY=='ON'" slot="word"><a class="s-link" @click="wechatPayConfig()">&nbsp;配置收款账户&nbsp;</a></span>
                        </c-form-item>
                        <c-form-item type="radio" label="支付宝支付" :options="switchOptions" v-model="ALI_PAY"  name="ALI_PAY" >
                            <span v-show="ALI_PAY=='ON'" slot="word"><a class="s-link" @click="aliPayConfig()">&nbsp;配置收款账户&nbsp;</a></span>
                        </c-form-item>
                        <c-form-item type="radio" label="提现代付" :options="switchOptions" v-model="WITHDRAWAL_AUTO_PAY"  name="WITHDRAWAL_AUTO_PAY" >
                        </c-form-item>
                        <c-form-item v-show="WITHDRAWAL_AUTO_PAY=='ON'"  type="radio" label="提现代付渠道" :options="autoPayChannelOptions"
                                     v-model="WITHDRAWAL_AUTO_PAY_CHANNEL"  name="WITHDRAWAL_AUTO_PAY_CHANNEL" >
                            <span v-show="WITHDRAWAL_AUTO_PAY_CHANNEL==1" slot="word"><a class="s-link" @click="autoPayChannelConfig()">&nbsp;身边云配置&nbsp;</a></span>
                            <span v-show="WITHDRAWAL_AUTO_PAY_CHANNEL==2" slot="word"><a class="s-link" @click="autoPayChannelConfig()">&nbsp;云账户配置&nbsp;</a></span>
                        </c-form-item>
                    </c-form>
                    <c-form title="功能控制">
                        <c-form-item type="radio" label="商品定制"  :options="switchOptions" v-model="PRODUCT_CUSTOM" name="PRODUCT_CUSTOM"
                                     word="">
                            <span slot="word">商品定制功能<a style="color:red">【分销配置->云仓囤货】</a>互斥，开启云仓囤货则定制功能必须关闭。</span>
                        </c-form-item>
                        <c-form-item type="radio" label="商品缺货订购" :options="switchOptions"  name="IS_OUTSTOCK"
                                   word="注:开启缺货订购后，具体哪些商品支持缺货订购需要在商品发布时自行指定"></c-form-item>
                        <c-form-item type="radio" v-show="PRODUCT_CUSTOM == 'ON'" label="定制库存共享"  :options="switchOptions"
                                     name="CUSTOM_PRODUCT_SHARE_STOCK" word="开启：定制商品共享普通库存；关闭：定制商品不限制库存"></c-form-item>
                        <c-form-item type="radio" label="积分体系"   :options="switchOptions" name="POINTS_SYSTEM" v-model="POINTS_SYSTEM">
                            <span v-show="POINTS_SYSTEM=='ON'"  power="m_points_regulation" slot="word"><a class="s-link" @click="navigateTo('/pionts_rule_config')">&nbsp;配置积分规则</a></span>
                        </c-form-item>
                        <c-form-item type="radio" label="订单审核"  :options="switchOptions"  name="ORDER_CHECK_ENABLED" ></c-form-item>
                        <c-form-item type="radio" label="预定活动"   :options="switchOptions"  name="PRESELL_ENABLED" ></c-form-item>
                        <c-form-item type="radio" label="砍价活动"   :options="switchOptions"  name="BARGAIN_ENABLED" ></c-form-item>
                        <c-form-item type="radio" label="售后审批"  :options="switchOptions"  name="RETURN_ORDER_CHECK_ENABLED" ></c-form-item>
                        <c-form-item type="radio" label="订单开票"  :options="switchOptions"  name="ORDER_INVOICE_ENABLED" ></c-form-item>
                        <c-form-item type="radio" label="代发地址"  :options="switchOptions"  name="AGENT_DELIVERY_ENABLED" ></c-form-item>
                    </c-form>
                </c-form>
            </module-tab>
            <module-tab title="分销配置">
                <c-form ref="form7">
                    <c-form-item type="radio" label="分销功能"  :options="switchOptions" v-model="SHARE_ENABLE"  name="SHARE_ENABLE">
                        <span v-show="SHARE_ENABLE=='ON'"  power="m_share" slot="word">请在<a class="s-link" @click="navigateTo('/distribution_config')">分销设置</a>功能中配置各等级分销奖励</span>
                    </c-form-item>
                    <c-form-item v-show="SHARE_ENABLE=='ON'"  type="radio" label="升级提示" :options="switchOptions" name="UPGRADE_TIP_ENABLE"
                                 word="开启提示则在商品详情、个人中心会展示升至下个代理等级的提示信息"></c-form-item>
                    <c-form-item type="radio" v-show="SHARE_ENABLE=='ON'" label="分销价格体系"  :options="agencyPriceMode" v-model="AGENCY_PRICE_MODE" name="AGENCY_PRICE_MODE">
                        <span slot="word" v-show="AGENCY_PRICE_MODE == 1" power="m_user_level">请在<a class="s-link" @click="navigateTo('/user_level_list')">代理等级</a>功能中，配置各等级的等级折扣信息</span>
                        <span slot="word" v-show="AGENCY_PRICE_MODE == 2" power="m_product_list">
                            请在<a class="s-link" @click="navigateTo('/product_list')">商品档案</a>功能中，设置各等级的商品售价，未做特殊配置则所有等级代理售价一致；
                            <span style="color:red">注：该模式下，价格管控中设置的特殊价无效</span>
                        </span>
                    </c-form-item>
                    <c-form-item v-show="SHARE_ENABLE == 'ON'" type="radio" label="上级承担优惠"  :options="switchOptions" name="AGENCY_BORNE_REDUCE">
                        <span slot="word">
                          【开启】则表示：如果下单人由于活动、积分、优惠券等减免，上级代理的“价差”相应减少；【关闭】则表示价差仅由等级售价而定，与活动、积分、优惠券等减免无关
                        </span>
                    </c-form-item>
                    <c-form-item v-show="SHARE_ENABLE == 'ON'" type="radio" label="云仓囤货"  :options="switchOptions" v-model="CLOUD_STOCK"  name="CLOUD_STOCK">
                        <span slot="word">云仓囤货开启则不允许定制，请关闭【平台配置->功能控制->商品定制】功能；云仓囤货相关规则说明请<a class="s-link" @click="$refs.tipDialog.open()">&nbsp;点击这里&nbsp;</a>查看</span>
                    </c-form-item>
                    <c-form-item v-show="SHARE_ENABLE == 'ON' && CLOUD_STOCK == 'ON'" type="select" label="囤货等级" options="USER_LEVEL_AUTH" v-model="CLOUD_STOCK_LEVEL"
                                 name="CLOUD_STOCK_LEVEL" word="注:大于或等于该等级的用户可以囤货">
                    </c-form-item>
                    <c-form-item v-show="SHARE_ENABLE == 'ON' && CLOUD_STOCK == 'ON'" type="radio" label="强制云仓出货"  :options="switchOptions" name="FORCE_CLOUD_DELIVER">
                        <span slot="word">开启【强制云仓出货】功能后，下级向上级进货，上级必须有足够的云仓库存，库存不足，则该订单无法继续流转</span>
                    </c-form-item>
                    <c-form-item v-show="SHARE_ENABLE == 'ON'" type="radio" label="自动转单"  :options="switchOptions" v-model="AUTO_TRANDFER"
                                 name="AUTO_TRANDFER" :word="autoTrandferTipWord">
                    </c-form-item>
                    <c-form-item v-show="SHARE_ENABLE == 'ON'" type="radio" label="代理自行发货"  :options="switchOptions" name="SELF_DELIVERY_ENABLE">
                        <span slot="word">
                            开启后，代理在审核下级订单是否，可以选择自行发货
                            <span style="color:red">允许自行发货的代理等级即【囤货等级】中配置的等级</span>
                        </span>
                    </c-form-item>
					<c-form-item v-show="SHARE_ENABLE == 'ON'" type="radio" label="货款返还"  :options="switchOptions" v-model="HK_BACK"
					             name="HK_BACK" word="向上级转单时,如果当前代理有货款,则解冻货款">
					</c-form-item>
                </c-form>
            </module-tab>
            <module-tab title="经销商配置">
                <c-form ref="form3">
                        <c-form-item type="radio" label="经销商店铺" v-model="OMS_SELLER_SHOP_ENABLED"  :options="switchOptions"  name="OMS_SELLER_SHOP_ENABLED"
                                     word="注:开启后，平台代理可以开通私有店铺分销平台商品"></c-form-item>
                        <c-form-item v-show="OMS_SELLER_SHOP_ENABLED == 'ON'" type="input" label="系统名称" name="SELLER_SYSTEM_NAME"></c-form-item>
                        <c-form-item v-show="OMS_SELLER_SHOP_ENABLED == 'ON'" type="image" label="登录页Logo" name="SELLER_LOGIN_LOGO" file-word="【建议尺寸：高度140px,宽度600px以内,支持jpg、png，图片大小1M以内】"></c-form-item>
                        <c-form-item v-show="OMS_SELLER_SHOP_ENABLED == 'ON'" type="image" label="内页Logo" name="SELLER_LOGO" file-word="【建议尺寸：400X88px,支持jpg、png，图片大小1M以内，最好是透明图】"></c-form-item>
                        <c-form-item v-show="OMS_SELLER_SHOP_ENABLED == 'ON'" type="image" label="ICON图标" name="SELLER_FAVICON" file-word="【建议尺寸：32X32px,支持jpg、png，图片大小1M以内】"></c-form-item>
                        <c-form-item v-show="OMS_SELLER_SHOP_ENABLED == 'ON'" type="input" label="版权信息" name="SELLER_COPYRIGHT" ></c-form-item>
                    </c-form>
            </module-tab>
            <module-tab title="阿里云配置">
                <c-form ref="form6">
                    <c-form title="基础配置">
                        <c-form-item type="input" label="会员公钥" name="OSS_ACCESSKEYID" word="注:阿里云OSS会员公钥（AccessKeyId）"></c-form-item>
                        <c-form-item type="input" label="会员私钥" name="OSS_ACCESSKEYSECRET" word="注:阿里云OSS会员私钥（AccessKeySecret）"></c-form-item>
                        <c-form-item type="input" label="存储空间名" name="OSS_BUCKETNAME" word="注:阿里云OSS中自定义的Bucket名称"></c-form-item>
                        <c-form-item type="input" label="上传地址URL" name="OSS_HOST" word="注:上传至阿里云oss的地址，不同区域的地址可能不同，示例：https://yci.oss-cn-hangzhou.aliyuncs.com/"></c-form-item>
                        <c-form-item type="input" label="访问地址前缀" name="OSS_ENDPOINT" word="注:上传完成的文件的访问地址前缀，示例：https://cdn.yunchange.com/"></c-form-item>
                        <c-form-item type="input" label="角色ARN" name="OSS_ROLEARN" word="注:控制OSS增删改查权限，可在阿里云后台，RAM访问控制->角色功能中查看"></c-form-item>
                    </c-form>
                    <c-form title="物流轨迹功能">
                        <c-form-item type="radio" label="物流轨迹查询功能"  v-model="EXPRESS_QUERY_ENABLED" :options="switchOptions"  name="EXPRESS_QUERY_ENABLED" ></c-form-item>
                        <c-form-item v-show="EXPRESS_QUERY_ENABLED == 'ON'" type="input" label="物流轨迹查询服务CODE" maxlength="200" name="EXPRESS_QUERY_APP_CODE" word="请填写阿里云服务APP Code"></c-form-item>
                    </c-form>
                    <c-form title="地址解析功能">
                        <c-form-item type="radio" label="地址解析功能"  v-model="ADDRESS_QUERY_ENABLED" :options="switchOptions"  name="ADDRESS_QUERY_ENABLED" ></c-form-item>
                        <c-form-item v-show="ADDRESS_QUERY_ENABLED == 'ON'" type="input" label="地址解析服务CODE" maxlength="200" name="ADDRESS_QUERY_APP_CODE" word="请填写阿里云服务APP Code"></c-form-item>
                    </c-form>
                    <c-form title="按图片搜索功能">
                        <c-form-item type="radio" label="按图片搜索" :options="switchOptions" name="OSS_IMAGESEARCH_ENABLED" v-model="OSS_IMAGESEARCH_ENABLED"></c-form-item>
                        <c-form-item type="input" label="区域ID" name="OSS_IMAGESEARCH_REGIONID" v-show="OSS_IMAGESEARCH_ENABLED == 'ON'"  word="注:请您填写成您购买实例的区域，例如您购买的实例区域为杭州，则填写cn-hangzhou"></c-form-item>
                        <c-form-item type="input" label="内网访问地址" name="OSS_IMAGESEARCH_ENDPOINT" v-show="OSS_IMAGESEARCH_ENABLED == 'ON'"  word="注:为内网访问（VPC）地址，请您更换为您购买实例的区域，例如您购买实例的区域为杭州，则填写imagesearch-vpc.cn-hangzhou.aliyuncs.com"></c-form-item>
                        <c-form-item type="input" label="实例名称" name="OSS_IMAGESEARCH_INSTANCENAME" v-show="OSS_IMAGESEARCH_ENABLED == 'ON'"  word="注:图像搜索实例名称。注意是实例名称不是实例ID。购买后通过 上云层管控台实例信息一栏查看"></c-form-item>
                    </c-form>
                </c-form>
            </module-tab>
            <module-tab title="聚水潭配置">
                <c-form ref="form4">
                    <c-form-item type="radio" label="聚水潭对接"  v-model="ORDER_PUSH_ENABLED" :options="switchOptions"  name="ORDER_PUSH_ENABLED" word="注:开启后,关联订单推送/产品资料推送/产品库存同步/售后单据推送"></c-form-item>
                    <c-form-item v-show="ORDER_PUSH_ENABLED == 'ON'" type="input" label="聚水潭接口地址" name="JUSHUITAN_API_URL" word="注:开启聚水潭对接时有效,结尾请保留“/”"></c-form-item>
                    <c-form-item v-show="ORDER_PUSH_ENABLED == 'ON'" type="input" label="聚水潭APP Key" name="JUSHUITAN_APP_KEY" word="注:开启聚水潭对接时有效"></c-form-item>
                    <c-form-item v-show="ORDER_PUSH_ENABLED == 'ON'" type="input" label="聚水潭APP Secret" name="JUSHUITAN_APP_SECRET" word="注:开启聚水潭对接时有效"></c-form-item>
                    <c-form-item v-show="ORDER_PUSH_ENABLED == 'ON'" type="input" label="聚水潭accessToken" name="JUSHUITAN_ACCESS_TOKEN" word="注:开启聚水潭对接时有效"></c-form-item>
                    <c-form-item v-show="ORDER_PUSH_ENABLED == 'ON'" type="input" label="聚水潭refreshToken" name="JUSHUITAN_REFRESH_TOKEN" word="注:开启聚水潭对接时有效"></c-form-item>
                    <c-form-item v-show="ORDER_PUSH_ENABLED == 'ON'" type="input" label="token过期时间" name="JUSHUITAN_EXPIRES_DATE" word="注:开启聚水潭对接时有效"></c-form-item>
                    <c-form-item v-show="ORDER_PUSH_ENABLED == 'ON'" type="input" label="自营店铺ID" :limit="[1,99999999999]" name="JUSHUITAN_SHOP_ID" word="注:开启聚水潭对接时有效"></c-form-item>
                </c-form>
            </module-tab>
            <template slot="button">
                <c-button size="m" power="b_platform_config_save" @click="save()">保存</c-button>
            </template>
        </module>

        <c-dialog ref="cashPayEdit" title="转账支付收款账户配置" width="700" @resolve="cashPaySubmit">
            <c-form ref="cashPayForm">
                <c-form-item type="input" label="收款银行" name="transfer_bank_name" required word="开户行名称，例：中国建设银行股份有限公司杭州延安支行"></c-form-item>
                <c-form-item type="input" label="收款户名" name="transfer_bank_account_name" required word="账户持有人，例如：中国移动杭州分公司"></c-form-item>
                <c-form-item type="input" label="收款账号" name="transfer_bank_account_number" required word="收款账户银行卡号"></c-form-item>
            </c-form>
        </c-dialog>

        <c-dialog ref="wechatPayEdit" title="微信收款账户配置" width="700" @resolve="wechatPaySubmit">
            <c-form ref="wechatPayForm">
                <c-form-item type="input" label="AppID" name="appID" required word="微信分配的小程序APP ID"></c-form-item>
                <c-form-item type="input" label="商户号" name="mchID" required word="微信支付分配的商户号ID"></c-form-item>
                <c-form-item type="input" label="密钥KEY" name="key" required word="安全检验码,用于加解密数据"></c-form-item>
                <c-form-item type="file" label="证书" name="cert_file" required file-word="请选择证书文件"></c-form-item>
            </c-form>
        </c-dialog>

        <c-dialog ref="aliPayEdit" title="支付宝收款账户配置" width="700" @resolve="aliPaySubmit">
            <c-form ref="aliPayForm">
                <c-form-item type="input" label="AppID" name="app_id" required word="支付宝收款账户ID"></c-form-item>
                <c-form-item type="input" label="收款账号" name="partner" required word="合作身份者ID，签约账号，以2088开头由16位纯数字组成的字符串，查看地址：https://b.alipay.com/order/pidAndKey.htm"></c-form-item>
                <c-form-item type="input" label="密钥KEY" name="key" required word="安全检验码，由数字和字母组成的32位字符串，查看地址：https://b.alipay.com/order/pidAndKey.htm"></c-form-item>
                <c-form-item type="textarea" label="秘钥" name="private_key" required word="支付宝秘钥"></c-form-item>
                <c-form-item type="textarea" label="公钥" name="public_key" required word="支付宝公钥"></c-form-item>
            </c-form>
        </c-dialog>
        <c-dialog ref="serviceShareEdit" title="身边云账户配置" width="700" @resolve="serviceShareSubmit">
            <c-form ref="serviceShareForm">
                <c-form-item type="input" label="服务商编号" name="PROVIDER_ID" required word="由身边云平台分配，请联系客服索取"></c-form-item>
                <c-form-item type="input" label="商户ID" name="MER_ID" required word="由身边云平台分配，请联系客服索取"></c-form-item>
                <c-form-item type="input" label="任务ID" name="TASK_ID" required word="由身边云平台分配，请联系客服索取"></c-form-item>
                <c-form-item type="input" label="版本号" name="API_VERSION" required word="一般默认为V1.0"></c-form-item>
                <c-form-item type="input" label="接口地址" name="YOU_FU_URL" required word="测试地址：http://testgateway.serviceshare.com/testapi/clientapi/clientBusiness/common；生产地址：https://api.serviceshare.com/clientapi/clientBusiness/common"></c-form-item>
                <c-form-item type="input" label="DES密钥" name="INTER_KEY" required word="请在身边云平台【接口设置】功能中查看，平台地址：https://merchant.serviceshare.com"></c-form-item>
                <c-form-item type="textarea" label="身边云平台公钥" name="YOU_FU_PUBLIC_KEY" required word="请在身边云平台【接口设置】功能中查看，平台地址：https://merchant.serviceshare.com"></c-form-item>
                <c-form-item type="textarea" label="商户公钥" name="MER_PUBLIC_KEY" required word="请在身边云平台【接口设置】功能中上传公钥信息，平台地址：https://merchant.serviceshare.com"></c-form-item>
                <c-form-item type="textarea" label="商户私钥" name="MER_PRIVATE_KEY" required word="根据【商户公钥】使用私钥进行签名得到（密钥长度：1024bit;密钥格式：PKSC#8;私钥密码可以为空），在线加密：https://www.bejson.com/enc/rsa/"></c-form-item>
            </c-form>
        </c-dialog>
        <c-dialog ref="yunzhanghuEdit" title="云账户账户配置" width="700" @resolve="yunzhanghuSubmit">
            <c-form ref="yunzhanghuForm">
                <c-form-item type="input" label="App Key" name="app_key" required word="由云账户平台分配，请联系客服索取"></c-form-item>
                <c-form-item type="input" label="平台企业ID" name="dealer_id" required word="由云账户平台分配，请联系客服索取"></c-form-item>
                <c-form-item type="input" label="服务主体ID" name="broker_id" required word="由云账户平台分配，请联系客服索取"></c-form-item>
                <c-form-item type="input" label="3DES 密钥" name="des_key" required word="由云账户平台分配，请联系客服索取"></c-form-item>
                <c-form-item type="textarea" label="云账户公钥" name="rsa_public_key" required word="由云账户平台分配，请联系客服索取，平台地址：https://service.yunzhanghu.com/"></c-form-item>
                <c-form-item type="textarea" label="平台企业私钥" name="rsa_private_key" required word="根据【平台企业公钥】使用私钥进行签名得到（密钥长度：1024bit;密钥格式：PKSC#8;私钥密码可以为空），在线加密：https://www.bejson.com/enc/rsa/"></c-form-item>
                <c-form-item type="input" label="接口地址" name="host_url" required word="沙箱环境地址：https://api-service.yunzhanghu.com/sandbox；生产地址：https://api-service.yunzhanghu.com"></c-form-item>
            </c-form>
        </c-dialog>
        <!--提示信息-->
        <c-dialog ref="tipDialog" title="云仓囤货规则说明" width="800" height="600"  button-name="知道了" :close-button="false" :cancel-button="false" >
            <div>
                <div class="import-steps">
                    <h5>开启【云仓囤货】后、“经销商”下单时，可以选择此次下单是【云仓囤货】或者【物流配送】</h5>
                    <p>
                        <strong style="color:black">1、</strong>下单选择【云仓囤货】：商品无需实际发货,不需要选择收货地址也不收取物流费用，下单支付成功后,由下单人的上级经销商“审核”该订单,
                        经销商审核【云仓囤货】订单时，有两种处理方式：【库存转移】【转上级处理】
                        <span style="color:dodgerblue">如果是最高等级经销商下云仓囤货单，则订单无需审批，支付完成直接增加云仓库存</span>
                    </p>
                    <p style="text-indent: 2em;">
                        <strong style="color:black">1.1)、</strong>【库存转移】：接单经销商的云仓库存充足，则可以选择“云仓转移”，自身的云仓库存减少，下单人的云仓库存增加，订单结束；
                        此种情况下，下单人所支付的所有订单商品费用将，全部归属接单经销商，作为其收益。
                    </p>
                    <p style="text-indent: 2em;">
                        <strong style="color:black">1.2)、</strong>【转上级处理】：上级经销商的云仓库存不足，则可以选择“转上级处理”，自身的云仓库无变化，由上级经销商对该订单进行进一步处理；
                        此种情况下，接单经销商可获得与下级下单人的商品价差，作为其收益。
                    </p>
                    <p>
                        <strong style="color:black">2、</strong>下单选择【物流配送】：商品需要实际发货，如果是实物商品，则需要选择收货地址，并根据配置收取物流费用；
                        下单支付成功后,由下单人的上级经销商“审核”该订单,
                        经销商审核【物流配送】订单时，有两种处理方式：【云仓发货】【转上级处理】
                        <span style="color:dodgerblue">如果是最高等级经销商下物流配送单，则订单无需审批，支付完成直接由平台处理</span>
                    </p>
                    <p style="text-indent: 2em;">
                        <strong style="color:black">2.1)、</strong>【云仓发货】：接单经销商的云仓库存充足，则可以选择“云仓发货”，自身的云仓库存减少，直接下单给平台，由平台进行发货；
                        此种情况下，下单人所支付的所有订单商品费用将，全部归属接单经销商，作为其收益。
                    </p>
                    <p style="text-indent: 2em;">
                        <strong style="color:black">2.2)、</strong>【转上级处理】：上级经销商的云仓库存不足，则可以选择“转上级处理”，自身的云仓库无变化，由上级经销商对该订单进行进一步处理；
                        此种情况下，接单经销商可获得与下级下单人的商品价差，作为其收益。
                    </p>
                </div>
            </div>

            <div>
                <div class="import-steps">
                    <h5>其他描述</h5>
                    <p>1)、非“经销商”会员无云仓囤货功能。</p>
                    <p>2)、非“经销商”会员下单，是直接向平台做采购，其邀请链路上的各级经销商可以享受差价奖励，但该种订单不可见，也无需经销商审核。</p>
                    <p>3)、下级“经销商”会员下单，其实是向其上级进货，与平台无实际关系；所以经销商下单无需考虑平台商品的实际库存
                        <span style="color:dodgerblue">最高等级经销商下单，需要考虑平台商品库存</span>
                    </p>
                </div>
            </div>
        </c-dialog>
    </page>
</template>

<script>
    export default {
        name: 'm_platform_config',

        props: {
            id: String
        },

        data() {
            return {
                OMS_SELLER_SHOP_ENABLED: 'OFF',
				ORDER_PUSH_ENABLED: 'OFF',
                EXPRESS_QUERY_ENABLED: 'OFF',
                ADDRESS_QUERY_ENABLED: 'OFF',
                PC_ENABLED: 'ON',//是否开启PC端
                MOBILE_ENABLED: 'ON',//是否开启移动端
                OSS_IMAGESEARCH_ENABLED: 'OFF',//支持按图片搜索
                POINTS_SYSTEM:'OFF',
                SHARE_ENABLE:'OFF',
                CLOUD_STOCK:'OFF',    //云仓囤货
                PRODUCT_CUSTOM:'OFF',  //商品支持定制
                IS_VIRTUAL_PRODUCT:'OFF',  //售卖虚拟商品
                AUTO_TRANDFER:'OFF',   //云仓囤货
				HK_BACK:'OFF',			//货款返还
                WECHAT_PAY:'OFF',
                ALI_PAY:'OFF',
                WITHDRAWAL_AUTO_PAY:'OFF',//提现代付，开启则需要对接第三方代付平台
                WITHDRAWAL_AUTO_PAY_CHANNEL:0,//提现代付渠道
				PT_MODE: 1,
                AGENCY_PRICE_MODE: 1,//代理价格体模式 1=按等级享受统一折扣；2=按等级设置商品售价
                CLOUD_STOCK_LEVEL:undefined,//允许囤货的最低等级，大于等于该等级可以囤货
                fromData:{
                    qiyukf_user_id:{id:'4',value:''},
                    oms_login_verify_switch:{id:'1',value:'ON'},
                    withdrawal_rate:{id:'2',value:''},
                    a_single_withdrawal_limit:{id:'3',value:''},
                    order_points_enabled:{id:'5',value:'ON'},
                    order_points_money_unit:{id:'6',value:''},
                    order_points_expired_period:{id:'7',value:''},
                    return_order_check_enabled:{id:'20',value:'ON'},
                },
                switchOptions: [
                    {name: '开启',value: 'ON'},
                    {name: '关闭',value: 'OFF'}
                ],
                ptMode: [
                    {name: '单平台运营',value: '1'},
                    {name: '多商户运营',value: '2'}
                ],
                saleMode: [
                    {name: '零售',value: '1'},
                    {name: '批发',value: '2'}
                ],
                occupancyTypeOptions: [
                    {name: '下单后占用',value: '1'},
                    {name: '支付后占用',value: '2'}
                ],
                skuCreateTypeOptions: [
                    {name: '货号+3位序号',value: 'productnumberseq'},
                    {name: '商品ID+3位序号',value: 'productidseq'}
                ],
                productTypeLevelOptions: [
                    {name: '一级',value: 1},
                    {name: '二级',value: 2},
                    {name: '三级',value: 3}
                ],
                productTypeLinkType: [
                    {name: '关联跳转链接',value: 1},
                    {name: '关联商品',value: 2}
                ],
                agencyPriceMode: [
                    {name: '按等级享受统一折扣',value: 1},
                    {name: '按等级设置商品售价',value: 2}
                ],
                autoPayChannelOptions: [
                    {name: '身边云',value: 1},
                    {name: '云账户',value: 2}
                ],
                memberOptions:[],
                cashReceiveAccount: {},          //转账支付支付收款账户信息
                wechatReceiveAccount: {},        //微信支付收款账户信息
                alipayReceiveAccount: {},        //支付宝收款账户信息
                serviceShareAccount: {},         //【身边云】代付账户信息
                yunzhanghuAccount: {}            //【云账户】代付账户信息
            }
        },

        watch: {
        },

        computed: {
            autoTrandferTipWord() {
                return {
                    'ON': '开启【自动转单】，下级下单后，会自动完成转单操作；允许【云仓囤货】，则默认使用【云仓发货】方式转单（库存不足则转单暂停）；未开启则默认使用【向上级转单】方式（开启强制云仓发货，则无该选项）',
                    'OFF': '关闭【自动转单】，下级下单后，订单会处于“待审核”状态，需要上级手动进行审单后，才会继续流转'
                }[this.AUTO_TRANDFER]
            }
        },

        mounted() {
            this.getDetail();
        },

        methods: {
            //回填数据
            getDetail() {
                this.request({
                    url: '/platform_config/list',
                    data: {
                        config_group: ""
                    },
                    loading: true,
                    success: data => {
                        let json = {};
                        data.forEach((item,i)=>{
                            var value = item.config_item_value;
                            if (item.config_item_code == 'WITHDRAWAL_RATE'){
                                value = value*100;
                            }
                            if (item.config_item_code == 'CASH_RECEIVE_ACCOUNT'){//转账支付支付账户
                                if (value){
                                    this.cashReceiveAccount = JSON.parse(value);
                                }
                            }else if (item.config_item_code == 'WECHAT_RECEIVE_ACCOUNT'){//微信支付账户
                                if (value){
                                    this.wechatReceiveAccount = JSON.parse(value);
                                }
                            }else if (item.config_item_code == 'ALIPAY_RECEIVE_ACCOUNT'){//支付宝支付账户
                                if (value){
                                    this.alipayReceiveAccount = JSON.parse(value);
                                }
                            }else if (item.config_item_code == 'SERVICE_SHARE_ACCOUNT'){//身边云代付账号
                                if (value){
                                    this.serviceShareAccount = JSON.parse(value);
                                }
                            }else if (item.config_item_code == 'YUNZHANGHU_ACCOUNT'){//云账户代付账号
                                if (value){
                                    this.yunzhanghuAccount = JSON.parse(value);
                                }
                            }else {
                                json[item.config_item_code] = value;
                            }
                        });
                        this.$nextTick(() => {
                            if(this.$refs.form0)this.$refs.form0.set(json);
                            if(this.$refs.form1)this.$refs.form1.set(json);
                            if(this.$refs.form3)this.$refs.form3.set(json);
                            if(this.$refs.form4)this.$refs.form4.set(json);
                            if(this.$refs.form6)this.$refs.form6.set(json);
                            if(this.$refs.form7)this.$refs.form7.set(json);

                            this.OMS_SELLER_SHOP_ENABLED = json.OMS_SELLER_SHOP_ENABLED;
                            this.ORDER_PUSH_ENABLED = json.ORDER_PUSH_ENABLED;
                            this.EXPRESS_QUERY_ENABLED = json.EXPRESS_QUERY_ENABLED;
                            this.ADDRESS_QUERY_ENABLED = json.ADDRESS_QUERY_ENABLED;
                            this.PC_ENABLED = json.PC_ENABLED;
                            this.MOBILE_ENABLED = json.MOBILE_ENABLED;
                            this.OSS_IMAGESEARCH_ENABLED = json.OSS_IMAGESEARCH_ENABLED;
                            this.POINTS_SYSTEM = json.POINTS_SYSTEM;
                            this.SHARE_ENABLE = json.SHARE_ENABLE;
                            this.CLOUD_STOCK = json.CLOUD_STOCK;
                            this.PRODUCT_CUSTOM = json.PRODUCT_CUSTOM;
                            this.IS_VIRTUAL_PRODUCT = json.IS_VIRTUAL_PRODUCT;
                            this.AUTO_TRANDFER = json.AUTO_TRANDFER;
							              this.HK_BACK = json.HK_BACK;
                            this.WECHAT_PAY = json.WECHAT_PAY;
                            this.WECHAT_PAY = json.WECHAT_PAY;
                            this.ALI_PAY = json.ALI_PAY;
                            this.WITHDRAWAL_AUTO_PAY = json.WITHDRAWAL_AUTO_PAY;
                            this.WITHDRAWAL_AUTO_PAY_CHANNEL = json.WITHDRAWAL_AUTO_PAY_CHANNEL||0;
                            this.PT_MODE = json.PT_MODE;
                            this.AGENCY_PRICE_MODE = json.AGENCY_PRICE_MODE;
                            this.CLOUD_STOCK_LEVEL = json.CLOUD_STOCK_LEVEL;
                        });
                    }
                });
            },
            /***
             保存数据
             ***/
            save() {
                if (this.PRODUCT_CUSTOM == 'ON' && this.CLOUD_STOCK == 'ON'){
                    this.$confirm({
                        text: '保存失败！【分销配置->云仓囤货】和【平台配置➩功能控制➩商品定制】功能不允许同时开启，请关闭其中一个后再提交数据',  // 提示内容,
                        buttonName: '知道了',  // 确定按钮文字
                        cancelButton: false  // 是否显示取消按钮
                    });
                    return;
                }
                if (this.IS_VIRTUAL_PRODUCT == 'ON' && this.CLOUD_STOCK == 'ON'){
                    this.$confirm({
                        text: '保存失败！【分销配置->云仓囤货】和【平台配置➩基本配置➩售卖虚拟商品】功能不允许同时开启，请关闭其中一个后再提交数据',  // 提示内容,
                        buttonName: '知道了',  // 确定按钮文字
                        cancelButton: false  // 是否显示取消按钮
                    });
                    return;
                }
                if (this.PC_ENABLED == 'OFF' && this.MOBILE_ENABLED == 'OFF'){
                    this.$confirm({
                        text: '保存失败！PC站和移动端至少开启一项，不能全部关闭',  // 提示内容,
                        buttonName: '知道了',  // 确定按钮文字
                        cancelButton: false  // 是否显示取消按钮
                    });
                    return;
                }
                if (this.WITHDRAWAL_AUTO_PAY == 'ON' &&(!this.WITHDRAWAL_AUTO_PAY_CHANNEL || this.WITHDRAWAL_AUTO_PAY_CHANNEL==0)){
                    this.$confirm({
                        text: '保存失败！您开启了【提现代付】，请选择代付渠道信息',  // 提示内容,
                        buttonName: '知道了',  // 确定按钮文字
                        cancelButton: false  // 是否显示取消按钮
                    });
                    return;
                }

                let data0 = this.$refs.form0?this.$refs.form0.get():{};
                let data1 = this.$refs.form1?this.$refs.form1.get():{};
                let data3 = this.$refs.form3?this.$refs.form3.get():{};
                let data4 = this.$refs.form4?this.$refs.form4.get():{};
                let data6 = this.$refs.form6?this.$refs.form6.get():{};
                let data7 = this.$refs.form7?this.$refs.form7.get():{};
                let submitData = Object.assign({}, data0, data1, data3, data4, data6,data7);
                console.log(submitData);
                let platform_config_list = [];
                for (let key in submitData) {
                    var value = submitData[key];
                    if (key == 'WITHDRAWAL_RATE'){
                        value = value/100;
                    }
                   /* if (key == 'SHARE_ENABLE'){
                        if (this.PT_MODE == 2){//所商户，则默认关闭分销功能
                            value = 'OFF';
                        }
                    }*/
                    platform_config_list.push({
                        config_item_code: key,
                        config_item_value: value || ''
                    });
                }
                this.request({
                    url: '/platform_config/edit',
                    data: {
                        platform_config_list: platform_config_list
                    },
                    loading: true,
                    success: data => {
                        this.$store.dispatch('getSystemConfig');
                        this.$confirm({
                            text:'系统配置数据保存成功，部分平台部分配置，需要<span style="color: red">重启ESB项目</span>后生效（如支付配置等）',  // 提示内容,
                            buttonName: '知道了',  // 确定按钮文字
                            cancelButton: false  // 是否显示取消按钮
                        });
                        //刷新页面
                        this.getDetail();
                    }
                });
            },
            //配置【转账支付支付】收款账户信息
            cashPayAccountConfig(){
                this.$refs.cashPayForm.set(this.cashReceiveAccount);
                this.$refs.cashPayEdit.open();
            },
            //配置【微信】收款账户信息
            wechatPayConfig(){
                this.$refs.wechatPayForm.set(this.wechatReceiveAccount);
                this.$refs.wechatPayEdit.open();
            },
            //提交转账支付支付数据
            cashPaySubmit(stop) {
                stop();
                this.$confirm({
                    text: '转账支付收款账户配置修改后，配置将立即生效，是否确认数据已正确填写？',  // 提示内容,
                    buttonName: '保存并生效',
                    cancelButton: false,
                    resolve: () => {
                        this.$refs.cashPayForm.submit({
                            url: '/platform_config/edit/by/code',
                            rule: {
                                transfer_bank_name: '请填写收款银行',
                                transfer_bank_account_name: '请填写收款户名',
                                transfer_bank_account_number: '收款账号'
                            },
                            dataFormatter: data => {
                                this.cashReceiveAccount = {
                                    transfer_bank_name:data.transfer_bank_name,
                                    transfer_bank_account_name:data.transfer_bank_account_name,
                                    transfer_bank_account_number:data.transfer_bank_account_number
                                }
                                var submitObj = {};
                                submitObj.config_item_code = 'CASH_RECEIVE_ACCOUNT';
                                submitObj.config_item_value = JSON.stringify(this.cashReceiveAccount);
                                return submitObj;
                            },
                            success:(data,res) => {
                                this.$message({
                                    text: '转账支付收款账户信息配置成功',
                                    icon: 'success'
                                });
                                this.$refs.cashPayEdit.close();
                            },
                        });
                    }
                });
            },

            //提交微信支付数据
            wechatPaySubmit(stop) {
                stop();
                this.$confirm({
                    text: '收款账户配置将立即生效，是否确认数据已正确填写？',  // 提示内容,
                    buttonName: '保存并生效',
                    cancelButton: false,
                    resolve: () => {
                        this.$refs.wechatPayForm.submit({
                            url: '/platform_config/edit/by/code',
                            rule: {
                                appID: '请填写AppID',
                                mchID: '请填写商户号',
                                key: '请填写密钥KEY',
                                cert_file: '请上传证书文件'
                            },
                            dataFormatter: data => {
                                this.wechatReceiveAccount = {
                                    appID:data.appID,
                                    mchID:data.mchID,
                                    key:data.key,
                                    cert_file:data.cert_file
                                }
                                var submitObj = {};
                                submitObj.config_item_code = 'WECHAT_RECEIVE_ACCOUNT';
                                submitObj.config_item_value = JSON.stringify(this.wechatReceiveAccount);
                                return submitObj;
                            },
                            success:(data,res) => {
                                this.$message({
                                    text: '微信收款账户信息配置成功',
                                    icon: 'success'
                                });
                                this.$refs.wechatPayEdit.close();
                            },
                        });
                    }
                });
            },

            //配置【支付宝】收款账户信息
            aliPayConfig(){
                this.$refs.aliPayForm.set(this.alipayReceiveAccount);
                this.$refs.aliPayEdit.open();
            },
            //提交【支付宝】收款账户信息
            aliPaySubmit(stop) {
                stop();
                this.$confirm({
                    text: '收款账户配置将立即生效，是否确认数据已正确填写？',  // 提示内容,
                    buttonName: '保存并生效',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.$refs.aliPayForm.submit({
                            url: '/platform_config/edit/by/code',
                            rule: {
                                app_id: '请填写AppID',
                                partner: '请填写收款账号',
                                key: '请填写密钥KEY',
                                private_key: '请填写支付宝秘钥',
                                public_key: '请填写支付宝公钥',
                            },
                            dataFormatter: data => {
                                this.alipayReceiveAccount = {
                                    app_id:data.app_id,
                                    partner:data.partner,
                                    key:data.key,
                                    private_key:data.private_key,
                                    public_key:data.public_key
                                }
                                var submitObj = {};
                                submitObj.config_item_code = 'ALIPAY_RECEIVE_ACCOUNT';
                                submitObj.config_item_value = JSON.stringify(this.alipayReceiveAccount);
                                return submitObj;
                            },
                            success:(data,res) => {
                                this.$refs.aliPayEdit.close();
                                this.$message({
                                    text: '支付宝收款账户信息配置成功',
                                    icon: 'success'
                                });
                            },
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
            /**
             * 配置【身边云】账户信息
             * @param type 1 = 身边云
             */
            autoPayChannelConfig(){
                if (this.WITHDRAWAL_AUTO_PAY_CHANNEL == 1){
                    this.$refs.serviceShareForm.set(this.serviceShareAccount);
                    this.$refs.serviceShareEdit.open();
                }else if (this.WITHDRAWAL_AUTO_PAY_CHANNEL == 2){
                    this.$refs.yunzhanghuForm.set(this.yunzhanghuAccount);
                    this.$refs.yunzhanghuEdit.open();
                }
            },
            //提交【身边云】账户信息
            serviceShareSubmit(stop) {
                stop();
                this.$confirm({
                    text: '收款账户配置将立即生效，是否确认数据已正确填写？',  // 提示内容,
                    buttonName: '保存并生效',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.$refs.serviceShareForm.submit({
                            url: '/platform_config/edit/by/code',
                            rule: {
                                PROVIDER_ID: '请填写商户服务商编号',
                                MER_ID: '请填写商户ID',
                                TASK_ID: '请填写任务ID',
                                API_VERSION: '请填写版本号',
                                YOU_FU_URL: '请填写接口地址',
                                INTER_KEY: '请填写DES密钥',
                                YOU_FU_PUBLIC_KEY: '请填写身边云平台公钥',
                                MER_PUBLIC_KEY: '请填写商户公钥',
                                MER_PRIVATE_KEY: '请填写商户私钥'
                            },
                            dataFormatter: data => {
                                this.serviceShareAccount = {
                                    PROVIDER_ID:data.PROVIDER_ID,
                                    MER_ID:data.MER_ID,
                                    TASK_ID:data.TASK_ID,
                                    API_VERSION:data.API_VERSION,
                                    YOU_FU_URL:data.YOU_FU_URL,
                                    INTER_KEY:data.INTER_KEY,
                                    YOU_FU_PUBLIC_KEY:data.YOU_FU_PUBLIC_KEY,
                                    MER_PUBLIC_KEY:data.MER_PUBLIC_KEY,
                                    MER_PRIVATE_KEY:data.MER_PRIVATE_KEY
                                }
                                var submitObj = {};
                                submitObj.config_item_code = 'SERVICE_SHARE_ACCOUNT';
                                submitObj.config_item_value = JSON.stringify(this.serviceShareAccount);
                                return submitObj;
                            },
                            success:(data,res) => {
                                this.$refs.serviceShareEdit.close();
                                this.$message({
                                    text: '身边云收款账户信息配置成功',
                                    icon: 'success'
                                });
                            },
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
            //提交【云账户】账户信息
            yunzhanghuSubmit(stop) {
                stop();
                this.$confirm({
                    text: '收款账户配置将立即生效，是否确认数据已正确填写？',  // 提示内容,
                    buttonName: '保存并生效',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.$refs.yunzhanghuForm.submit({
                            url: '/platform_config/edit/by/code',
                            rule: {
                                app_key: '请填写App Key',
                                dealer_id: '请填写平台企业ID',
                                broker_id: '请填写综合服务主体ID',
                                des_key: '请填写 3DES 密钥',
                                rsa_private_key: '请填写平台企业私钥',
                                rsa_public_key: '请填写云账户公钥',
                                host_url: '请填写接口域名地址'
                            },
                            dataFormatter: data => {
                                this.yunzhanghuAccount = {
                                    app_key:data.app_key,
                                    dealer_id:data.dealer_id,
                                    broker_id:data.broker_id,
                                    des_key:data.des_key,
                                    rsa_private_key:data.rsa_private_key,
                                    rsa_public_key:data.rsa_public_key,
                                    host_url:data.host_url
                                }
                                var submitObj = {};
                                submitObj.config_item_code = 'YUNZHANGHU_ACCOUNT';
                                submitObj.config_item_value = JSON.stringify(this.yunzhanghuAccount);
                                return submitObj;
                            },
                            success:(data,res) => {
                                this.$refs.yunzhanghuEdit.close();
                                this.$message({
                                    text: '【云账户】账户信息配置成功',
                                    icon: 'success'
                                });
                            },
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
        }
    }
</script>

<style lang="stylus" scoped>
    .import-steps {
        padding: 10px 20px;
        background-color: #F8F8F8;

        h5 {
            line-height: 36px;
            font-size: 15px;
        }

        p {
            padding: 4px 3px;
            line-height: 20px;
            color: #666;
        }
    }
</style>